function sleep(time) { // time is ms
  return new Promise(resolve => setTimeout(resolve, time));
}

export default sleep;